<script>
import Swal from "sweetalert2";
// import Multiselect from 'vue-multiselect'

import CatalogTitle from "@/components/catalog-title"

import ItemsApi from "@/services/items-api";
import OrdersApi from "@/services/orders-api";

import Order from "@/router/views/orders/orderComponent"
import QuantityCart from "@/components/QuantityCart"

export default {
  props: {
  selectedSupplier:{
    type: Number,
  },
  selectedPromotion:{
    type: Number,
    default:null
  },
  suppliersOfferType:{
      type: Number,
  },
  minOrderValuePara:{
    type:Number
  },
  minOrderValuePharma:{
    type:Number
  },
  isCashPaymentMandatory:{
    type:Number,
    default:0
  },
  minItemsNbre:{
    type:Number,
    default:0
  },
},
components: { CatalogTitle/** ,Multiselect */,Order, QuantityCart  },
  data( ) {
    return {
      itemsFilter: '',
      isItemsTableBusy: false,
      isParaItemsTableBusy:false,
      isPharmaItemsTableBusy:false,
      pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
      pagemodelMainSecond: {currentPage : 1, perPage : 15, totalRows: 0},

      orderLines: [{itemTitle: '', price: '', id:''}],
      order: {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0,taxStampValue:0,isTaxStampEnabled:false},

      itemsList: [],
      paraItemsList:[],
      pharmaItemsList:[],
      OrdersList: [],

      showImageModal: false,
      imageModalUrl: '',
      isOrderQuantityEdit: false,
      isSubmittingOrder: false,
      cashPaymentDiscount:0,
      cashPaymentState:this.order === undefined  ? (this.isCashPaymentMandatory!=0 ? 0 : 1) : this.order.paymentDays,


      orderFields: [
        { key:"itemTitle", label: "Article", sortable: true, tdClass:"p-0"},
        { key:"quantity", label: "Qte", sortable: false, tdClass:"text-right", thClass:"text-right", thStyle:"width:65px"},
        { key:"price", label: "P.U (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:100px"},
      ],

      draftFields: [
        {key:"actions", label:""},
        { key:"ref", label: "Réference", sortable: false, tdClass:"pt-2"},
        { key:"date", label: "Date de Creation", sortable: true, tdClass:"text-right pt-2", thClass:"text-right"},
      ],
      draftLines:[],
      draftsPagination: {currentPage : 1, perPage : 10, totalRows: 0},
      isDraftsTableLoading: false,
      isAddToOrderStarting:false,
      selectedGroup:null,
      groupsList:[],
      isCheckingCondition:false,
      showOrdersDetailsModal:false,
      orderMessage: '',

      isOrderOverview:false,

      quantityKey:0,
    }
  },
  mounted(){
    this.orderLines = [];
    this.getAllGroups()
    this.findItems();
    if(this.isCashPaymentMandatory!=0){
      this.cashPaymentState=0
    }
    this.getCashPaymentDiscount();
    

   
  },

  computed: {
    totalQuantity() {
      if (!this.order?.lines?.length) {
        return 0;
      }

      return this.order.lines.reduce((sum, line) => {
        if (line.isGratuity) return sum;
        return sum + (line.quantity || 0);
      }, 0);
    },

    isPromoValid() {
      return this.totalQuantity >= this.minItemsNbre;
    },

    progressPercent() {
      return Math.min(
        100,
        (this.totalQuantity / this.minItemsNbre) * 100
      );
    },

    remainingItems() {
      return Math.max(
        0,
        this.minItemsNbre - this.totalQuantity
      );
    }
  
  },

  methods: {
    findItems() {
      this.isItemsTableBusy = true;
      if(!this.selectedPromotion) {
        ItemsApi.findItems(this.itemsFilter, this.selectedSupplier, this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.selectedGroup===null ? null : this.selectedGroup.id)
        .then(itemsList => {
          if(itemsList){
          this.itemsList = itemsList.list
          this.pagemodelMain.totalRows = itemsList.total;
          this.pagemodelMain.currentPage = itemsList.page;
          this.pagemodelMain.perPage = itemsList.pageSize;
          this.pagemodelMain.pageSize = itemsList.pageSize;
          }
        })
        .finally(() => {
        this.isItemsTableBusy = false;
        this.itemsList.forEach(function(item){
              item.quantity = 1;
          });
      })
      }
      else {
        if(this.suppliersOfferType===1){
          ItemsApi.findPromotionItems(this.itemsFilter, this.selectedSupplier, this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.selectedPromotion,null,this.selectedGroup===null ? null : this.selectedGroup.id)
          .then(itemsList => {
            if(itemsList){
            this.itemsList = itemsList.list
            this.pagemodelMain.totalRows = itemsList.total;
            this.pagemodelMain.currentPage = itemsList.page;
            this.pagemodelMain.perPage = itemsList.pageSize;
            this.pagemodelMain.pageSize = itemsList.pageSize;
            }
          })
          .finally(() => {
          this.isItemsTableBusy = false;
          this.itemsList.forEach(function(item){
                item.quantity = 1;
            });
          })
        }
        if(this.suppliersOfferType===2){
          this.isParaItemsTableBusy = true;
          this.isPharmaItemsTableBusy = true;
          ItemsApi.findPromotionItems(this.itemsFilter, this.selectedSupplier, this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.selectedPromotion,1,this.selectedGroup===null ? null : this.selectedGroup.id)
          .then(itemsList => {
            if(itemsList){
            this.paraItemsList = itemsList.list
            this.pagemodelMain.totalRows = itemsList.total;
            this.pagemodelMain.currentPage = itemsList.page;
            this.pagemodelMain.perPage = itemsList.pageSize;
            this.pagemodelMain.pageSize = itemsList.pageSize;
            }
          })
          .then(() => {
          this.paraItemsList.forEach(function(item){
                item.quantity = 1;
            });
          }).finally(() =>{
            this.isParaItemsTableBusy = false;
          })
          ItemsApi.findPromotionItems(this.itemsFilter, this.selectedSupplier, this.pagemodelMainSecond.currentPage, this.pagemodelMainSecond.perPage,this.selectedPromotion,0,this.selectedGroup===null ? null : this.selectedGroup.id)
          .then(itemsList => {
            if(itemsList){
            this.pharmaItemsList = itemsList.list
            this.pagemodelMainSecond.totalRows = itemsList.total;
            this.pagemodelMainSecond.currentPage = itemsList.page;
            this.pagemodelMainSecond.perPage = itemsList.pageSize;
            this.pagemodelMainSecond.pageSize = itemsList.pageSize;
            }
          })
          .then(() => {
          this.pharmaItemsList.forEach(function(item){
                item.quantity = 1;
            });
          }).finally(()=> {
            this.isPharmaItemsTableBusy = false;
          })
        }
      }
    },

    addToOrder(data) {
      this.$refs['active-tab'].activate()
      this.isAddToOrderStarting=true
      OrdersApi.addLineToOrder(this.order.id, data.id, data.quantity, this.selectedSupplier,this.selectedPromotion,this.isChecked(this.cashPaymentState)) 
      .then(order => {
        if(order) {
          this.orderLines = order.lines;
          this.order = order; 
        }
        }).then(()=>{
          this.isAddToOrderStarting=false
        }).finally(()=>{
          this.isAddToOrderStarting=false
        })
    },

    editOrderLine(item){
      OrdersApi.editLineToOrder(this.order.id, item.itemId, item.editedQuantity, this.selectedSupplier, this.selectedPromotion,this.isChecked(this.cashPaymentState)) 
      .then(order => {
        if(order) {
          this.orderLines = order.lines;
          this.order = order; 

        }
      })
      .finally(() => {
        item.isOrderQuantityEdit = false

      }) 

      
    },

    removeOrderLine(item){

        Swal.fire({
        title: "Supprimer ?",
        html: item.itemTitle,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, supprimer!"
      }).then(result => {
        if (result.value) {
          OrdersApi.removeOrderLine(this.order.id, item.itemId,this.selectedSupplier,this.isChecked(this.cashPaymentState))
          .then(order => {
            if (!order) {
              this.clearAll()
            } else {
              this.orderLines = order.lines;
              this.order = order;
            }
          })
        }
      });
    },

    askSubmitOrder(){

        Swal.fire({
        title: "Valider la commande ?",
        html: "La commande sera envoyée au fournisseur",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, envoyer!"
      }).then(result => {
        if (result.value) {
          this.submitOrder();
        }
      });
    },

    submitOrder() {
        this.isSubmittingOrder = true;
        this.order.deliveryAddress = this.selectedDeliveryAddress;
        this.order.message = this.orderMessage;
        OrdersApi.submitOrder(this.order.id, this.orderMessage, this.selectedPriority, this.selectedDeliveryAddress,this.isChecked(this.cashPaymentState))
        .then(result => {
              if(result.isSubmitted) {
                this.isSubmittingOrder = false;
                this.clearAll();
                this.$emit('update', true)
              }
          })
        .finally(() => {
          this.isSubmittingOrder = false; 
          this.showOrdersDetailsModal=false
        })
      },
    getDrafts(){
      this.isDraftsTableLoading=true
      OrdersApi.getOrdersByCustomerAndPromtion(this.draftsPagination.currentPage, this.draftsPagination.perPage,this.selectedSupplier,true,this.selectedPromotion,null)
      .then(drafts => {
        if(drafts){
        this.draftLines = drafts.list
        this.draftsPagination.totalRows = drafts.total;
        this.draftsPagination.currentPage = drafts.page;
        this.draftsPagination.perPage = drafts.pageSize;
        this.draftsPagination.pageSize = drafts.pageSize;
        }

      })

      .finally(() => {
        this.isDraftsTableLoading=false 
      })
    },
    removeDraft(draft){
        Swal.fire({
        title: "Supprimer le brouillon?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, supprimer!"
      }).then(result => {
        if(result.value){
          OrdersApi.removeDraft(draft).then(
            isRemoved => {
              if (isRemoved) {
                 this.getDrafts()
                 this.clearAll();
              }
            }
          )
        }
      })
    },
      cancelOrder(){
      Swal.fire({
      title: "Supprimer le brouillon?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      cancelButtonText: "Annuler",
      confirmButtonText: "Oui, supprimer!"
    }).then(result => {
      if(result.value){
        OrdersApi.removeDraft(this.order).then(
          isRemoved => {
            if (isRemoved) {
                this.clearAll();
            }
          }
        )
      }
    })
  },
  getOrderLines(draft){
    this.$refs['active-tab'].activate();
    OrdersApi.getOrderLines(draft.id).then(
      order => {
        if (order){
          this.orderLines=order.lines
          this.order=order
          this.cashPaymentState= this.order.paymentDays === null  ? 1 : this.order.paymentDays
        }

      }
    )

  },
  clearAll(){
    this.orderLines=[]
    this.order= {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0};
  },
  getCashPaymentDiscount(){
    OrdersApi.getCashPaymentDiscount(this.selectedSupplier,this.selectedPromotion).then(
      result => {
        this.cashPaymentDiscount= result === undefined || result == null ? 0 : result;
      }
    )
  },
  editCashPaymentDiscount(cashPaymentState){
    OrdersApi.editCashPaymentDiscount(this.order,this.isChecked(cashPaymentState)).then(
      order => {
        if(order){
          this.order=order
        }
        
      }
    )
  },

  isChecked(cashPaymentState){
    if(cashPaymentState == 0 || cashPaymentState === 0 ) return true
    return false;
  },

  getAllGroups(){
    ItemsApi.getAllGroups(this.selectedSupplier, this.selectedPromotion ? this.selectedPromotion : null).then(
        result => {
            this.groupsList=result;
        }
    )
  },

  exportPDF(){
    ItemsApi.exportPDF(this.selectedPromotion ? this.selectedPromotion : this.selectedSupplier,this.selectedPromotion ? true : false)
  },

   checkCondition(){
      this.isOrderOverview = false
      this.isCheckingCondition = true;
      OrdersApi.checkCondition(this.order.id, this.orderMessage, this.selectedPriority, this.selectedDeliveryAddress,this.isChecked(this.cashPaymentState))
      .then(isChecked => {
       if (isChecked) {
           this.isCheckingCondition = false;
           this.showOrdersDetailsModal =true;
        }
      }).finally(()=>{
        this.isCheckingCondition = false;
      });
    },

  setPaymentState(){
    this.cashPaymentState =0;
  },

  selectPaymentMethod(paymentMethods){
    OrdersApi.editPaymentMethod(this.order, paymentMethods)
      .then(order => {
            if(order){
              this.order=order
              this.isOrderOverview = true
            }
      });
  }

  },
  watch : {
    cashPaymentState : function(cashPaymentState) {
          this.editCashPaymentDiscount(cashPaymentState) 
    },

    selectedGroup :function(){
      this.findItems()
    }
  }
  
}
</script>

<style scoped>
  .sticky-col {
  position: -webkit-sticky;
  position: -moz-sticky;
  position: -ms-sticky;
  position: -o-sticky;
  position: sticky;
  background-color: white;
}

.first-col {
  width: 100px;
  min-width: 160px;
  max-width: 160px;
  left: 0px;
}
</style>

<template>
<div>

<div class="row pl-6 pb-2 pl-2">
  <div class="col-sm-9 ">
    <v-select variant="success"  class="style-vselect" style="font-size:12px;min-width:150px; background-color:#f8f9fa; " :options="groupsList"  v-model="selectedGroup" placeholder="Filtrer par Groupes d'Articles" label="name"  >
        <span slot="no-options">Aucun élément dans la liste</span>
    </v-select> 
  </div>

  <!-- <div class="col-sm-4 pl-sm-2">
    <v-select variant="success"  class="style-vselect" style="font-size:12px;min-width:150px; background-color:#f8f9fa; " :options="groupsList"  v-model="selectedGroup" placeholder="Filtrer par Marques" label="name"  >
        <span slot="no-options">Aucun élément dans la liste</span>
    </v-select> 
  </div> -->
</div>

<div class="row pl-2">
  <div class ="col-sm-8 pb-4 ">
        <b-input-group  >
          <!-- <template v-slot:prepend>
            <v-select variant="success"  class="style-vselect" style="font-size:12px;min-width:150px" :options="groupsList" v-model="selectedGroup" placeholder="Groupes" label="name"  >
                <span slot="no-options">Aucun élément dans la liste</span>
            </v-select> 
          </template> -->

          <b-form-input placeholder="Chercher par Référence ou Désignation ou Marque"  v-model="itemsFilter"   @keyup.native.enter="findItems()"
              ></b-form-input>                              
          <template v-slot:append>
              <b-button variant="success" @click="findItems()">
              <i class="bx bx-search-alt font-size-16 align-middle"></i>
              </b-button>
              <!-- <b-button @click.prevent="exportPDF" class="ml-2"  size="sm" variant="info" title="Exporter le catalogue en PDF" >
                <i class="fas fa-print font-size-16 align-middle "></i> 
              </b-button>  -->
          </template>
        </b-input-group>
    </div>
    <div class ="col-sm-1 pb-4  pr-2 text-right d-none d-sm-block">
      <b-button @click.prevent="exportPDF" class="ml-2 h-100 w-100"  size="sm" variant="info" title="Exporter le catalogue en PDF" >
        <i class="fas fa-print font-size-16 align-middle "></i> 
      </b-button> 
    </div>
  <div class="col-sm-3 pl-sm-2 pr-1 pb-4 d-none d-lg-block">
    <div class="custom-file">
      <input id="customFile" type="file" class="custom-file-input" disabled/>
      <label class="custom-file-label" for="customFile">Importer une commande XLS</label>
    </div>
  </div>

</div>



<div class="row pl-2">


  <!-- Single catalog section -->
  <div v-if="!this.selectedPromotion || this.suppliersOfferType===1" class ="col-lg-9 col-md-9 col-sm-7 col-xs-12 ">
    <div  class="card border border-info bg-Default">
    <div  class="table-responsive mb-0" :style="[selectedPromotion ? {'min-height': '650px','max-height': '650px' } : {'min-height': '745px','max-height': '745px'}]">

      <table class="table table-centered table-fixed ">
        <thead class="thead-light">
            <tr>
                
                <th class="text-left sticky-col first-col">Désignation</th>
                <!-- <th class="text-left">Référence</th> -->
                <th class="text-left ">Marque </th>
                <!-- <th class="text-left ">Groupe </th> -->
                <th class="text-center ">Image</th>
                <th  :class="selectedPromotion ? 'text-right' : 'text-right '">Prix HT</th>
                <th class="text-right">Remise</th>
                <th :class="selectedPromotion && suppliersOfferType===1 ? 'text-right' : 'text-right'">Prix HT Négocié</th>
                <th class="text-right ">Gratuités</th>
                <th class="text-right ">Stock</th>
                <th :class="selectedPromotion ? 'text-left ' : 'd-none'">DLC</th>
                <th class="text-right"> Multiple</th>
                <th style="width:95px"></th>
            </tr>
        </thead>

        <tbody>

          <tr v-for="data in itemsList" :key="data.id" >
            
            <td class="text-left font-weight-bold font-size-14 sticky-col first-col">{{data.title}}
              <span :class="selectedPromotion && data.isMandatory? '' : 'd-none'"
              class="badge ml-1 badge-danger badge-pill">Obligatoire</span>      <span :class="data.isNew ? '' : 'd-none'" class="badge ml-1 badge-success font-weight-bold text-white badge-pill">New</span>    </td>
            <!-- <td class="text-left">{{data.ref}}</td> -->
            <td class="text-left " v-if="data.brand===null">{{data.brand}}</td>
            <td class="text-left " v-else>{{data.brand.name}}</td>
            <!-- <td class="text-left " v-if="data.itemGroup===null">{{data.itemGroup}}</td> 
            <td class="text-left " v-else>{{data.itemGroup.name}}</td> -->
            <td class="text-center ">
                <img v-show="!isItemsTableBusy" v-bind:src="'/api/image/get/' + data.image" @click="imageModalUrl= '/api/image/get/' + data.image;showImageModal = true" alt height="40" style="cursor: pointer;" />
            </td>

            <td class= "text-right font-size-14 ">{{data.price}}</td>
            <td class="text-right font-weight-bold font-size-14">
              {{data.discount === null || data.discount === 0 ? '' : data.discount+'%'}} 
            </td>

            <td :class="selectedPromotion && suppliersOfferType===1 ? 'text-right font-weight-bold text-success font-size-14 ' : 'text-right font-weight-bold text-success font-size-14'">
              {{data.discountedPrice}}
            </td>

            <td v-if="!data.gratuity || data.gratuity.length === 0 " class="text-right font-weight-bold font-size-14">
            </td>

            <td v-else
                class="text-right pull-right font-weight-bold font-size-14">

              <div v-for="(gratuity, index) in data.gratuity" :key="index">
                <span
                  class="badge badge-primary font-size-14 m-1"
                >
                  <i class="fas fa-star mr-2"></i>
                  {{ gratuity.gratuity }} +{{ gratuity.gratuityGranted }}
                </span>
              </div>

            </td>
            
            <td class="text-right  "> 
              <i v-if="!data.isAvailable" title="Non disponible" class="bx bx-x-circle text-danger font-size-18"> </i>
              <i v-if="data.isAvailable" title="Disponible en stock" class="fas fa-check-double text-primary font-size-16"> </i>
            </td>
            <td :class="selectedPromotion ? 'text-left  font-size-14' : 'd-none'">
              {{data.formattedExpirationDate}}
            </td>

            <td class="text-right"><span class="font-size-14 font-weight-bold">{{data.multiple}} x</span></td>
            <td aria-colindex="8" role="cell" class="font-weight-bold align-middle ">

              <QuantityCart
                v-model="data.quantity"
                v-if="data.isAvailable"
                :loading="isAddToOrderStarting"
                @add="addToOrder(data)"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="isItemsTableBusy" class="d-flex justify-content-center">
        <div class="spinner-border text-success" role="status">
          <span class=" sr-only">Loading...</span>
        </div>
      </div>
      <span v-if="!isItemsTableBusy & !itemsList.length" class="d-flex justify-content-center m-4 text-danger" >Pas d'articles dans le tableau </span>

    </div>

 </div>
  <!-- Pagination -->
  <div class="row pt-3 mb-sm-4">
      <div class="col-sm-8">
          <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
              <b-form-select @input="findItems()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
              <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
          </div>
      </div>
      <div class="col-sm-4">
          <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="pagemodelMain.currentPage" :disabled="isItemsTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findItems()" ></b-pagination>
              </ul>
          </div>
      </div>
  </div> 
  <!-- Fin Pagination  -->

  </div>

  <!-- Seperate (two) catalogs section -->
 <div v-if="(this.selectedPromotion && this.suppliersOfferType===2)" class ="col-lg-9 col-md-9 col-sm-7 col-xs-12 ">
  
  <!-- First Catalog -->
  <CatalogTitle title="Catalogue Parapharmaceutique" :min="minOrderValuePara" :value="order.totalPara" :valueStr="order.totalParaStr"/>
  <div  class="card border border-info bg-Default">
    <div  class="table-responsive mb-0" style="height:400px">
      <table class="table table-centered table-fixed ">
        <thead class="thead-light">
            <tr>
                <th class="text-left sticky-col first-col">Désignation</th>
                <!-- <th class="text-left ">Référence </th> -->
                <th class="text-left ">Marque </th>
                <th class="text-left ">Groupe </th>
                <th class="text-center ">Image</th>
                <th class="text-right ">Prix HT</th>
                <th class="text-right ">Remise</th>
                <th class="text-right " >Prix HT Négocié</th>
                <th class="text-right ">Gratuités</th>
                <th class="text-right ">Stock</th>
                <th class="text-left ">DLC</th>
                <th class="text-right"> Multiple</th>
                <th style="width:95px"></th>
            </tr>
        </thead>

        <tbody>
          <tr v-for="data in paraItemsList" :key="data.id" >
            
            <td class="text-left font-weight-bold font-size-14 sticky-col first-col">{{data.title}}
              <span :class="selectedPromotion && data.isMandatory? '' : 'd-none'"
              class="badge ml-1 badge-danger badge-pill">Obligatoire</span></td>
            <!-- <td class="text-left ">{{data.ref}}</td> -->
            <td class="text-left " v-if="data.brand===null">{{data.brand}}</td>
            <td class="text-left " v-else>{{data.brand.name}}</td>
            <td class="text-left " v-if="data.itemGroup===null">{{data.itemGroup}}</td>
            <td class="text-left " v-else>{{data.itemGroup.name}}</td>
            <td class="text-center ">
                <img v-show="!isParaItemsTableBusy" v-bind:src="'/api/image/get/' + data.image" @click="imageModalUrl= '/api/image/get/' + data.image;showImageModal = true" alt height="40" style="cursor: pointer;" />
            </td>
            <td class= "text-right font-size-14 ">{{data.price}}</td>
            <td class="text-right font-weight-bold font-size-14 ">{{data.discount === null || data.discount === 0 ? '' : data.discount+'%'}} </td>

            <td class="text-right font-weight-bold text-success font-size-14">{{data.discountedPrice}}</td>

            <td v-if="!data.gratuity || data.gratuity.length === 0 " class="text-right font-weight-bold font-size-14">
            </td>

            <td v-else
                class="text-right pull-right font-weight-bold font-size-14">

            <div v-for="(gratuity, index) in data.gratuity" :key="index">
                <span
                class="badge badge-primary font-size-14 m-1"
                >
                <i class="fas fa-star mr-2"></i>
                {{ gratuity.gratuity }} +{{ gratuity.gratuityGranted }}
                </span>
            </div>

            </td>
            
            <td class="text-right  "> 
              <i v-if="!data.isAvailable" title="Non disponible" class="bx bx-x-circle text-danger font-size-18"> </i>
              <i v-if="data.isAvailable" title="Disponible en stock" class="fas fa-check-double text-primary font-size-16"> </i>
            </td>
            <td :class="selectedPromotion ? 'text-left  font-size-14' : 'd-none'">
              {{data.formattedExpirationDate}}
            </td>

            <td class="text-right"><span class="font-size-14 font-weight-bold">{{data.multiple}} x</span></td>
            <td aria-colindex="8" role="cell" class="font-weight-bold align-middle ">

              <QuantityCart
                v-model="data.quantity"
                v-if="data.isAvailable"
                :loading="isAddToOrderStarting"
                @add="addToOrder(data)"
              />

            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="isParaItemsTableBusy" class="d-flex justify-content-center">
        <div class="spinner-border text-success" role="status">
          <span class=" sr-only">Loading...</span>
        </div>
      </div>
      <span v-if="!isParaItemsTableBusy & !paraItemsList.length " class="d-flex justify-content-center m-4 text-danger" >Pas d'articles dans le tableau </span>
    </div>
 </div>
      <!-- Pagination -->
      <div class="row pt-3 mb-sm-4">
          <div class="col-sm-8">
              <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                  <b-form-select @input="findItems()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                  <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
              </div>
          </div>
          <div class="col-sm-4">
              <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                  <b-pagination v-model="pagemodelMain.currentPage" :disabled="isParaItemsTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findItems()" ></b-pagination>
                  </ul>
              </div>
          </div>
      </div> 
      <!-- Fin Pagination  -->

    <!-- Second Catalog -->
    <CatalogTitle title="Catalogue Médicaments" :min="minOrderValuePharma" :value="order.totalPharma" :valueStr="order.totalPharmaStr" />
    <div  class="card border border-info bg-Default">
    <div  class="table-responsive mb-0" style="height:400px">
      <table class="table table-centered table-fixed ">
        <thead class="thead-light">
            <tr>
              
                <th class="text-left sticky-col first-col">Désignation</th>
                <!-- <th class="text-left ">Référence </th> -->
                <th class="text-left ">Marque </th>
                <th class="text-left ">Groupe </th>
                <th class="text-center ">Image</th>
                <th class="text-right ">Prix HT</th>
                <th class="text-right ">Remise</th>
                <th class="text-right " >Prix HT Négocié</th>
                <th class="text-right ">Gratuités</th>
                <th class="text-right ">Stock</th>
                <th class="text-left ">DLC</th>
                <th class="text-right"> Multiple</th>
                <th style="width:95px"></th>
            </tr>
        </thead>

        <tbody>
          <tr v-for="data in pharmaItemsList" :key="data.id" >
            
            <td class="text-left font-weight-bold font-size-14 sticky-col first-col">{{data.title}}
              <span :class="selectedPromotion && data.isMandatory? '' : 'd-none'"
              class="badge ml-1 badge-danger badge-pill">Obligatoire</span></td>
            <!-- <td class="text-left ">{{data.ref}}</td> -->
            <td class="text-left " v-if="data.brand===null">{{data.brand}}</td>
            <td class="text-left " v-else>{{data.brand.name}}</td>
            <td class="text-left " v-if="data.itemGroup===null">{{data.itemGroup}}</td>
            <td class="text-left " v-else>{{data.itemGroup.name}}</td>
            <td class="text-center ">
                <img v-show="!isPharmaItemsTableBusy" v-bind:src="'/api/image/get/' + data.image" @click="imageModalUrl= '/api/image/get/' + data.image;showImageModal = true" alt height="40" style="cursor: pointer;" />
            </td>
            <td class= "text-right font-size-14 ">{{data.price}}</td>
            <td class="text-right font-weight-bold font-size-14 ">{{data.discount === null || data.discount === 0 ? '' : data.discount+'%'}} </td>

            <td class="text-right font-weight-bold text-success font-size-14">{{data.discountedPrice}}</td>

            <td v-if="!data.gratuity || data.gratuity.length === 0 " class="text-right font-weight-bold font-size-14">
            </td>

            <td v-else
                class="text-right pull-right font-weight-bold font-size-14">

            <div v-for="(gratuity, index) in data.gratuity" :key="index">
                <span
                class="badge badge-primary font-size-14 m-1"
                >
                <i class="fas fa-star mr-2"></i>
                {{ gratuity.gratuity }} +{{ gratuity.gratuityGranted }}
                </span>
            </div>

            </td>
            
            <td class="text-right  "> 
              <i v-if="!data.isAvailable" title="Non disponible" class="bx bx-x-circle text-danger font-size-18"> </i>
              <i v-if="data.isAvailable" title="Disponible en stock" class="fas fa-check-double text-primary font-size-16"> </i>
            </td>
            <td :class="selectedPromotion ? 'text-left  font-size-14' : 'd-none'">
              {{data.formattedExpirationDate}}
            </td>

            <td class="text-right"><span class="font-size-14 font-weight-bold">{{data.multiple}} x</span></td>
            <td aria-colindex="8" role="cell" class="font-weight-bold align-middle ">

              <QuantityCart
                v-model="data.quantity"
                v-if="data.isAvailable"
                :loading="isAddToOrderStarting"
                @add="addToOrder(data)"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="isPharmaItemsTableBusy" class="d-flex justify-content-center">
        <div class="spinner-border text-success" role="status">
          <span class=" sr-only">Loading...</span>
        </div>
      </div>
      <span v-if="!isPharmaItemsTableBusy & !pharmaItemsList.length" class="d-flex justify-content-center m-4 text-danger" >Pas d'articles dans le tableau </span>
    </div>
 </div>

    <!-- Pagination -->
    <div class="row pt-3 mb-sm-4">
        <div class="col-sm-8">
            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                <b-form-select @input="findItems()"  v-model="pagemodelMainSecond.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMainSecond.totalRows}} lignes</span></div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="pagemodelMainSecond.currentPage" :disabled="isPharmaItemsTableBusy" :per-page="pagemodelMainSecond.pageSize" :total-rows="pagemodelMainSecond.totalRows" @input="findItems()" ></b-pagination>
                </ul>
            </div>
        </div>
    </div> 
    <!-- Fin Pagination  -->

 </div>
 <div  class="col-lg-3 col-md-3 col-sm-5 col-xs-12" style=" padding-left: 10px; padding-right: 11px;">
    <b-tabs justified nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold text-uppercase ">
      <b-tab ref="active-tab" lazy >

        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-cart-plus font-size-14"></i>
          </span>
          <i class="d-none d-sm-inline-block fas fa-cart-plus font-size-14 pr-2"/><span class="d-none d-sm-inline-block font-size-14">Commande</span>
        </template>
          <h5 class="card-title mt-3 mb-0 text-secondary text-center">Bon de commande</h5><br> 

          <div v-if="this.suppliersOfferType===1 && this.minItemsNbre>0" class="p-3">

            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="font-weight-bold text-dark font-size-16 text-uppercase">
                Votre commande
              </span>

              <span
                class="badge px-3 py-2 font-size-13"
                :class="isPromoValid ? 'badge-success-soft' : 'badge-warning-soft'"
              >
                <i
                  :class="isPromoValid ? 'fas fa-check-circle' : 'fas fa-box-open'"
                  class="mr-1"
                ></i>

                {{ totalQuantity }} / {{ minItemsNbre }}
              </span>
            </div>

            <!-- Progress bar -->
            <div class="progress progress-sm mb-1">
              <div
                class="progress-bar"
                role="progressbar"
                :style="{
                  width: progressPercent + '%'
                }"
                :class="isPromoValid ? 'bg-success' : 'bg-warning'"
              ></div>
            </div>

            <small class="text-muted">
              {{ remainingItems }} article(s) restant(s)
            </small>

          </div>

          <div class="row pb-3 pt-3" >
              <div class="col-11" >
                <b-form-checkbox
                  value="0"
                  unchecked-value="1"
                  class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                  v-model="cashPaymentState"
                  :disabled=" isCashPaymentMandatory!=0"
                  >
                  <span class="text-muted" ><span class="d-none d-sm-inline-block"> Paiement au </span> Comptant <span v-if="cashPaymentDiscount !=0"> (Remise de <span>{{this.cashPaymentDiscount}} </span>%<span class="d-none d-sm-inline-block"> suppl</span>)</span></span>
                </b-form-checkbox>
              </div>

              <div class="col-1">
                
                <a title="Annuler la commande" href="javascript:void(0);"  @click="cancelOrder()" class="action-icon text-danger">
                <i class="fas fa-times font-size-14" />
              </a>  
              </div>
            </div>
     
        <!-- <div class="table-responsive mb-0" :style="[selectedPromotion ? {'min-height': '285px','max-height':'285px'} : {'min-height': '415px','max-height':'415px' }]"> -->
        <div class="table-responsive mb-0" :style="[selectedPromotion ? (suppliersOfferType===2 ? {'min-height': '595px','max-height':'595px'}  : {'min-height': '325px','max-height':'325px'} ) : {'min-height': '425px','max-height':'425px' }]">

        <b-table
            :striped="true"
            :small="true"
            :hover="true"
            :items="orderLines"
            :fields="orderFields"
            sortKey="itemTitle"
            responsive
          >
          <template v-slot:cell(itemTitle)="{item,value}">
              <a v-if="!item.isGratuity" title="supprimer" href="javascript:void(0);"  @click="removeOrderLine(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-danger">
                <i class="mdi mdi-trash-can font-size-18" />
              </a>  
              <i v-if="item.isGratuity" class="fas fa-star text-primary font-size-12 " />
              <span class="text-black ml-2">{{value}}</span>                                          
          </template>

          <template v-slot:cell(quantity)="{value, item}">
              <span v-if="!item.isOrderQuantityEdit" class="text-black">{{value}}</span>      
              <a  v-if="!item.isOrderQuantityEdit && !item.isGratuity" @click="item.isOrderQuantityEdit = true" title="Changer la quantité" href="javascript:void(0);" :class="item.itemId ? '' : 'd-none'" class="action-icon text-warning">
                <i class="fas fa-pencil-alt  ml-2 font-size-13"  @click="item.isOrderQuantityEdit = true; item.editedQuantity = item.quantity;"/>
              </a>
              <i v-if="item.isGratuity" class="fas fa-star text-primary invisible  ml-2 font-size-12 " />

              <div v-if="item.isOrderQuantityEdit" class="input-group input-group-sm pull-right mb-0" style="width:85px;">
                <b-form-input v-model="item.editedQuantity" type="number" name="number" size="sm" class="no-shadow p-1" @keyup.native.enter="editOrderLine(item)"></b-form-input>
                  <div class="input-group-append"  size="sm" >
                    <b-button variant="link"  size="sm" title="Changer la quantité"><i class="font-size-12 fas fa-pencil-alt text-warning" @click="editOrderLine(item)"></i></b-button>
                  </div>
              </div>
          </template>

        </b-table>

        </div>
        <div class="table-responsive mt-4" >
          <table class="table table-centered mb-0 table-nowrap table-sm borderless">
            <tbody>

              <tr>
                <td colspan="3">
                  <h6 class="m-0 text-right font-weight-bold text-right font-weight-bold text-primary"> Total Remise</h6>
                </td>
                                                      
                <td class="text-right text-primary font-weight-bold">{{order.discountAmount}}</td>
              </tr> 
              <tr>
                <td colspan="3">
                  <h6 class="m-0 text-right font-weight-bold text-right">Total HT</h6>
                </td>
                <td class="text-right">{{order.total}}</td>
              </tr>
              <tr>
                <td colspan="3">
                  <h6 class="m-0 text-right">Taxes</h6>
                </td>
                <td class="text-right">{{order.taxes}}</td>
              </tr>
              <tr>
                <td colspan="3">
                  <h6 class="m-0 text-right">T.V.A.</h6>
                </td>
                <td class="text-right">{{order.vat}}</td>
              </tr>
              <tr v-if="order!=undefined && order.isTaxStampEnabled">
                <td colspan="3">
                  <h6 class="m-0 text-right">Timbre Fiscal</h6>
                </td>
                <td class="text-right">{{order.taxStamp}}</td>
              </tr>

              <tr>
                <td colspan="3">
                  <h6 class="m-0 text-right font-weight-bold text-primary">Total TTC</h6>
                </td>
                <td class="text-right text-primary font-weight-bold">{{order.totalWithTaxes}}</td>
              </tr>
            </tbody>
          </table>


          <div class="row pb-0 pt-3">
            <div class="col-sm-12">
                <b-button variant="success" style="width:100%" @click="checkCondition()" :disabled="this.isCheckingCondition || !this.orderLines.length">
                  <b-spinner small :class="this.isCheckingCondition ? '' : 'd-none'"></b-spinner>
                  <i class="bx bx-check-double font-size-24 align-middle mr-2"></i> <span class="font-weight-bold font-size-14">Aperçu de la commande</span>
                </b-button>
            </div>
          </div>

        </div>
      </b-tab>
      <b-tab @click="getDrafts()" lazy >
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-archive font-size-14"></i>
          </span>
          <i class="d-none d-sm-inline-block fas fa-archive font-size-14 pr-2"/><span class="d-none d-sm-inline-block font-size-14">Brouillons</span>
        </template>
        <h5 class="card-title mt-3 mb-0 text-secondary text-center">Liste des Brouillons</h5><br>
        <div class="table-responsive mb-0">
        <b-table
            :busy="isDraftsTableLoading"
            :striped="true"
            :small="true"
            :hover="true"
            :items="draftLines"
            :fields="draftFields"
            sortKey="date"
          >
        <template v-slot:cell(ref)="{value,item}">
              <a  title="" href="javascript:void(0);"  @click="getOrderLines(item)" >
                {{value}}
              </a>  
        </template>

        <template v-slot:cell(actions)="{item}">
              <a  title="supprimer" href="javascript:void(0);"  @click="removeDraft(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-danger">
                <i class="mdi mdi-trash-can font-size-18" />
              </a>  
        </template>
        <template v-slot:table-busy>
          <div class="text-center m-2">
              <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </div>
        </template>
        </b-table>
        <span v-if="!isDraftsTableLoading & !draftLines.length" class="d-flex justify-content-center m-4 text-danger" >Pas de brouillons dana la liste</span>
        <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getDrafts()"  v-model="draftsPagination.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{draftsPagination.totalRows}} lignes</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="draftsPagination.currentPage" :disabled="isDraftsTableLoading" :per-page="draftsPagination.pageSize" :total-rows="draftsPagination.totalRows" @input="getDrafts()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
        </div> 

      </b-tab>
      </b-tabs>
 </div>
</div>

 <b-modal v-model="showImageModal" 
        title="L'image de l'article" 
        hide-footer 
        centered 
        title-class="text-warning"
        title-tag="h5"
        header-close-variant="danger">
       
       <div class="row p-2 zoom-container">
          <img v-bind:src="imageModalUrl"  alt height="100%" width="100%" />
       </div>
       

    </b-modal>

      <b-modal
      v-if="order.id"
      v-model="showOrdersDetailsModal"
      centered 
      class="modal-fullscreen"
      :size="isOrderOverview ? 'xl' : 'md'"
      full-screen
      hide-footer 
      hide-header
      >
      <div v-if="isOrderOverview" class=" zoom-container">
        <div class="modal-order-header">
          <h5 class="text-warning d-print-none">
            Aperçu de la commande
          </h5>

          <div >
              <i class="fas fa-times text-dark" @click="showOrdersDetailsModal = false"></i>
          </div>
        </div>

            <div class="form-group row mb-1">
              <label class="col-md-12 text-success col-form-label font-size-16">Souhaitez-vous ajouter un commentaire à la commande ?</label>
              <div class="col-md-12">
                  <!-- Editor -->
                  <textarea
                    v-model="orderMessage"
                    class="form-control"
                    :maxlength="255"
                    rows="3"
                    placeholder="Ajouter une note à la commande si vous le souhaitez (max 250 caractères)."
                  ></textarea>
                  <div class="text-center">
                    <p
                      v-if="orderMessage"
                      class="badge position-absolute"
                      :class="{ 'badge-success': orderMessage.length !== 255,
                                'badge-danger': orderMessage.length === 255 }"
                    >
                      {{ orderMessage.length }} /
                      255
                    </p>
                  </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 text-right d-print-none ">
                  <b-button variant="danger" style="width:30%" @click="askSubmitOrder()" :disabled="this.isSubmittingOrder || !this.orderLines.length">
                            <b-spinner small :class="this.isSubmittingOrder ? '' : 'd-none'"></b-spinner>
                            <i class="fa fa-paper-plane font-size-24 align-middle mr-2"></i> 
                            <span class="font-weight-bold font-size-14">Envoyer la Commande</span>
                          </b-button>
                </div>
            </div>

      <Order :orderId= this.order.id :isCatalogList=true  />

      <div class="col-sm-12 pr-4 text-right d-print-none ">
        <b-button variant="danger" style="width:30%" @click="askSubmitOrder()" :disabled="this.isSubmittingOrder || !this.orderLines.length">
                  <b-spinner small :class="this.isSubmittingOrder ? '' : 'd-none'"></b-spinner>
                  <i class="fa fa-paper-plane font-size-24 align-middle mr-2"></i> 
                  <span class="font-weight-bold font-size-14">Envoyer la Commande</span>
                </b-button>
      </div>
      </div>

    <div v-else-if="order.paymentDays === 0" class="text-center">
        <img src="@/assets/images/warning.gif" height="100" class="mt-4 mb-5"/>

      <div class="mb-2 font-size-16 text-dark">
        Vous avez choisi un paiement <strong class="text-uppercase">Comptant</strong>
      </div>
      <div class="mb-3 font-size-16 text-dark">
        Veuillez choisir le mode de paiement
      </div>
      <div class="d-flex justify-content-center gap-2 ">
        <button class="btn btn-outline-dark text-uppercase" @click="selectPaymentMethod(2)">
          <div class="text-uppercase font-weight-bold">Par Chèque</div> 
          <div class="font-weight-normal font-size-12">Bancaire</div>  
        </button>
        <button class="btn btn-outline-dark ml-2 text-uppercase" @click="selectPaymentMethod(1)">
          <div class="text-uppercase font-weight-bold">Par Virement</div> 
          <div class="font-weight-normal font-size-12">Bancaire</div>
        </button>
      </div>
    </div>

    <div v-else class=" text-center">
      <img src="@/assets/images/warning.gif" height="100" class="mt-4 mb-5"/>

      <p class="mb-2 font-size-16">
        Vous avez choisi un paiement <strong class="text-uppercase">à échéance</strong>.
      </p>
      <div class="mb-3 font-size-16">
        Veuillez choisir le mode de paiement
      </div>
      
      <div class="d-flex justify-content-center gap-2 mt-4">
        <button class="btn btn-outline-dark " @click="selectPaymentMethod(0)">
          <div class="text-uppercase font-weight-bold">Par Traite</div> 
          <div class="font-weight-normal font-size-12">Bancaire</div>
        </button>
        <button class="btn btn-outline-dark ml-2" @click="selectPaymentMethod(1)">
          <div class="text-uppercase font-weight-bold">Par Virement</div> 
          <div class="font-weight-normal font-size-12">à échéance</div>
        </button>
        <button class="btn btn-danger ml-2" @click="setPaymentState()">
          <div class="text-uppercase font-weight-bold">Payer au Comptant</div> 
          <div v-if="cashPaymentDiscount !=0" class="font-weight-normal font-size-12">(Remise de <span>{{this.cashPaymentDiscount}} </span>%) </div>
        </button>
      </div>
    </div>



      </b-modal>
        </div>


</template>


<style scoped>
.modal-order-header{
  justify-content: space-between;
  display: flex;
}
</style>

